import { defaultTimeZone, defaultLocales } from './constants';
import { isDate } from './isDate';
import { isInvalidDate } from './isInvalidDate';

/**
 * Converts a Date object into a time only string.
 *
 * e.g. 7:30 AM
 * @param {*} date a Date object you want to convert into a string - gracefully handles any value
 * @param {object} options -
 * @param {string} options.timeZone - the timezone you want date displayed in, defaults to current users time zone
 * @returns {string} a formatted date string
 */
export const timeOnlyString = (
  date: unknown,
  { timeZone = defaultTimeZone }: DateOnlyStringOptions = {},
): string => {
  if (!isDate(date) || isInvalidDate(date)) {
    return '';
  }

  try {
    return new Intl.DateTimeFormat(defaultLocales, {
      timeStyle: 'short',
      timeZone,
    }).format(date);
  } catch (error: unknown) {
    console.error(error); // eslint-disable-line no-console
    return ''; // handle bad input
  }
};
